<template>
    <div>
        <div class="nextNevigation  d-md-none" v-bind:class="{'d-lg-block':arrows.right}">
            <router-link v-bind:to="arrows.rightRoute"><i class="fa fa-angle-right" style="font-size: 42px"></i>
            </router-link>

        </div>
        <div class="PrevNevigation  d-md-none" v-bind:class="{'d-lg-block':arrows.left}">
            <router-link v-bind:to="arrows.leftRoute"><i class="fa fa-angle-left" style="font-size: 42px"></i>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "sideArrows",
        props: ['arrows'],
    }
</script>

<style scoped>
    .nextNevigation {
        position: absolute;
        color: #4192D9;
        right: 10rem;
    }

    .PrevNevigation {
        position: absolute;
        color: #4192D9;
        left: 10rem;
    }

</style>
